import { render, staticRenderFns } from "./add.vue?vue&type=template&id=85c81ad8&scoped=true"
import script from "./add.vue?vue&type=script&lang=js"
export * from "./add.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85c81ad8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/web-SaaS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('85c81ad8')) {
      api.createRecord('85c81ad8', component.options)
    } else {
      api.reload('85c81ad8', component.options)
    }
    module.hot.accept("./add.vue?vue&type=template&id=85c81ad8&scoped=true", function () {
      api.rerender('85c81ad8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/security/channelManage/components/add.vue"
export default component.exports